import { LOAN_API_URL } from '@portal/config/env';
import {
  getInstance,
  getCleanInstance,
} from '@portal/repositories/securitySdkConfig';

const BASE_URL = `${LOAN_API_URL}/loan`;
const PRE_APPROVED_BASE_URL = `${LOAN_API_URL}/pre-approved-loan`;

const LoanApi = {
  getPreApproved: async (): Promise<models.PreApprovedLoan[]> => {
    const instance = getInstance();
    const { data } = await instance.get<models.PreApprovedLoan[]>(
      PRE_APPROVED_BASE_URL
    );

    return data;
  },

  getLoans: async (): Promise<bank.Loan[]> => {
    const instance = getInstance();
    const { data } = await instance.get<bank.Loan[]>(BASE_URL);

    return data;
  },

  updateAccount: async (
    account: models.CompleteAccountRequest
  ): Promise<void> => {
    const instance = getInstance();
    await instance.put(`${LOAN_API_URL}/account`, {
      account,
    });
  },

  getSimulation: async (
    id: string,
    amount: number
  ): Promise<models.LoanSimulation[]> => {
    const instance = getInstance();
    const { data } = await instance.post<models.LoanSimulation[]>(
      `${PRE_APPROVED_BASE_URL}/${id}/simulation`,
      {
        loan: {
          amount,
        },
      }
    );

    return data;
  },

  getExternalSimulation: async (
    id: string,
    simulation: models.ExternalSimulationRequest
  ): Promise<models.LoanExternalSimulation> => {
    const instance = getInstance();
    const { data } = await instance.post<models.LoanExternalSimulation>(
      `${PRE_APPROVED_BASE_URL}/${id}/external-simulation`,
      simulation
    );

    return data;
  },

  createLoan: async (
    preApprovedLoanId: string,
    simulation: models.LoanExternalSimulation,
    loanBankAccountData: models.LoanBankAccountData
  ): Promise<bank.Loan> => {
    const instance = getInstance();
    const { data } = await instance.post<bank.Loan>(BASE_URL, {
      ...simulation,
      ...loanBankAccountData,
      preApprovedLoanId,
    });

    return data;
  },

  getWarrantyUploadUrl: async (
    loanId: string,
    fileExtension: string
  ): Promise<{ url: string; bucket: string }> => {
    const instance = getInstance();
    const { data } = await instance.get<{ url: string; bucket: string }>(
      `${BASE_URL}/${loanId}/get-warranty-url?fileExtension=${fileExtension}`
    );

    return data;
  },

  uploadWarranty: async (url: string, file: Buffer): Promise<void> => {
    const instance = getCleanInstance(url);
    const { data } = await instance.put('', file, {
      headers: {
        'Content-Type': 'application/pdf',
      },
    });

    return data;
  },

  requestAnalyze: async (loanId: string): Promise<void> => {
    const instance = getInstance();
    const { data } = await instance.post(
      `${BASE_URL}/${loanId}/request-analyze`
    );

    return data;
  },

  getLoanSettings: async () => {
    const instance = getInstance();
    const { data } = await instance.get<models.LoanSettings>(
      `${LOAN_API_URL}/settings`
    );

    return data;
  },

  saveLoanIntention: async (type: number): Promise<void> => {
    const instance = getInstance();
    const { data } = await instance.post(`/interest-in-new-products`, { type });

    return data;
  },
};

export default LoanApi;
